import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { LearnMoreLink } from '@bingads-webui-campaign-react/help';
import { Icon } from '@bingads-webui-react/fabric-control';

import { getItemPlaceholderBoxViewStyle } from './style';

export const ItemPlaceholderBoxViewFooterType = {
  info: 'info',
  warning: 'warning',
};

export const ItemPlaceholderBoxView = ({
  className,
  mainViewIcon,
  mainViewIconLabel,
  footerProps,
}) => {
  const {
    type,

    fabricIconName,
    fabricIconClassName,

    summary,
    tip,
    learnMoreLinkText,
    learnMoreLinkTopic,
  } = footerProps || {};

  const classes = useDefaultStyles(getItemPlaceholderBoxViewStyle);

  const renderFooter = useCallback(() => {
    let content;

    if (footerProps) {
      content = (
        <div className={classnames(
            classes.footerContainer,
            type === ItemPlaceholderBoxViewFooterType.warning && classes.footerInvalid
          )}
        >
          {
            fabricIconName
              ? <Icon iconName="Warning" className={fabricIconClassName} />
              : <Spinner size={SpinnerSize.small} />
          }

          <div className={classes.footerContent}>
            {
              summary &&
              <span className={classes.footContentStatus}><b>{summary}</b></span>
            }
            {
              tip &&
              <React.Fragment>
                <span>&nbsp;</span>
                <span>{tip}</span>
              </React.Fragment>
            }
            {
              learnMoreLinkText && learnMoreLinkTopic &&
              <React.Fragment>
                <span>&nbsp;</span>
                <LearnMoreLink
                  linkText={learnMoreLinkText}
                  topic={learnMoreLinkTopic}
                />
              </React.Fragment>
            }
          </div>
        </div>
      );
    }

    return content;
  }, [classes.footContentStatus, classes.footerContainer, classes.footerContent, classes.footerInvalid, fabricIconClassName, fabricIconName, footerProps, learnMoreLinkText, learnMoreLinkTopic, summary, tip, type]);

  return (
    <div className={classnames(classes.container, className)}>
      <div className={classes.mainViewContainer}>
        <div className={classes.mainViewContentContainer}>
          <img src={mainViewIcon} className={classes.contentIcon} alt="" />
          <span className={classes.mainViewIconLabelContainer}>{mainViewIconLabel}</span>
        </div>
      </div>
      {renderFooter()}
    </div>
  );
};

ItemPlaceholderBoxView.propTypes = {
  className: PropTypes.string,
  mainViewIcon: PropTypes.string.isRequired,
  mainViewIconLabel: PropTypes.string.isRequired,
  footerProps: PropTypes.shape({
    type: PropTypes.oneOf(Object.keys(ItemPlaceholderBoxViewFooterType)),
    renderIcon: PropTypes.func,
    summary: PropTypes.string,
    tip: PropTypes.string,
    learnMoreLinkText: PropTypes.string,
    learnMoreLinkTopic: PropTypes.string,
  }),
};

ItemPlaceholderBoxView.defaultProps = {
  className: '',
  footerProps: {},
};
